import { render } from "./LocalKeywordRankings.vue?vue&type=template&id=679801c9&scoped=true"
import script from "./LocalKeywordRankings.vue?vue&type=script&lang=js"
export * from "./LocalKeywordRankings.vue?vue&type=script&lang=js"

import "./LocalKeywordRankings.vue?vue&type=style&index=0&id=679801c9&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679801c9"]])

export default __exports__